<template>
	<div class="modal-tbf smaller">
		<div class="container-modal" v-if="loaded">
			<div class="header-modal">
				<div class="title">
					{{ $t('reports.people_report_title') }}
				</div>
				<div class="related_date">{{ requiredData.start_date | moment('DD MMM ') }} - {{ requiredData.end_date | moment('DD MMM ') }}</div>
				<div class="actions">
					<button class="btn-default-tbf close-btn" @click="closeModal"><icon-plus class="icon-close" /></button>
				</div>
			</div>

			<div class="info-content">
				<div class="container-content-modal">
					<div class="report-people">
						<div class="report-item" v-for="user in reportData">
							<div class="column-tbf user-img" v-if="$resize && $mq.above(780)">
								<v-popover offset="0" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" popoverClass="description-popover" :delay="{show: 0, hide: 0}" >
									<img :src="user.avatar" v-if="user.avatar">
									<div class="user-circle" v-else>
										<icon-user-settings/>
									</div>

									<template slot="popover">
										<div class="simple-text">{{ user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1) + ' ' + user.last_name }}</div>
									</template>
								</v-popover>
							</div>

							<div class="column-tbf row-title">
								<div class="text-medium" v-html="user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1) + ' ' + user.last_name"></div>
							</div>

							<div class="column-tbf column-value promises-count-width" v-if="$resize && $mq.above(780)">
								<div class="label">{{ $t('reports.promise_set')}}</div>
								<div class="value">{{  $tc('reports.promises_count', user.total_promises) }}</div>
							</div>

							<div class="column-tbf column-value percent-width">
								<div class="label">{{ $t('reports.percent_ratio')}}</div>
								<div class="value">{{ user.completed_promises_percent }}%</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import IconPlus from "../Icons/Plus"
	import IconInfo from "../Icons/Info"
	import IconUserSettings from '../Icons/UserSettings'

	export default {
		data() {
			return {
				loaded: false,
				reportData: []
			};
		},
		props: {
			requiredData: Object
		},
		components: {
			IconPlus,
			IconInfo,
			IconUserSettings
		},
		mounted() {
			this.getReportPeoplePercentRatio()
		},
		methods: {
			closeModal(){
				this.$emit("toggle_modal");
			},
			getReportPeoplePercentRatio(){
				axios.get(`/reports/${this.$auth.user().instance_id}/company/people-promises-completed`, {
					params: {
						start_date: this.requiredData.start_date, 
						end_date: this.requiredData.end_date 
				    }  
				})
				.then(({data}) => {
					this.reportData = data.data
				})
				.finally(() => {
					this.loaded = true
				})
			}
		}
	};
</script>